import React, { useState } from "react";

const langOptions = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "zh", label: "中文" },
];

const contactLabels = {
  en: "Contact Us",
  es: "Contáctanos",
  zh: "联系我们",
};

export default function Navbar({ setLang }) {
  const [currentLang, setCurrentLang] = useState("en");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleContactClick = () => {
    window.open('https://wa.me/34607413270', '_blank');
  };

  const handleLangSelect = (code) => {
    setCurrentLang(code);
    setLang(code);
    setDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src="/logo.png" alt="Henson Systems" className="logo-img" />
        <span>Henson Systems</span>
      </div>

      <div className="navbar-actions">
        <div className="lang-dropdown-container">
          <button className="lang-dropdown-button" onClick={toggleDropdown}>
            {langOptions.find((opt) => opt.code === currentLang)?.label}
            <svg
              className={`dropdown-arrow ${dropdownOpen ? "open" : ""}`}
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>

          {dropdownOpen && (
            <div className="lang-dropdown-menu">
              {langOptions.map((option) => (
                <button
                  key={option.code}
                  className="lang-dropdown-item"
                  onClick={() => handleLangSelect(option.code)}
                >
                  {option.label}
                </button>
              ))}
            </div>
          )}
        </div>

        <button className="contact-nav-button" onClick={handleContactClick}>
          {contactLabels[currentLang]}
        </button>
      </div>
    </nav>
  );
}
